"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Mariam.Melkonyan on 11/14/2016.
 */
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var sis_audit_trail_component_1 = require("./audit-trail/sis-audit-trail.component");
var de_export_component_1 = require("./de-export/de-export.component");
var de_head_menu_component_1 = require("./de-head-menu/de-head-menu.component");
var sis_document_row_component_1 = require("./document-row/sis-document-row.component");
var sis_entity_search_component_1 = require("./entity-search/sis-entity-search.component");
var material_module_1 = require("./material.module");
var sis_message_box_popup_component_1 = require("./message-box/sis-message-box-popup.component");
var translate_message_pipe_1 = require("./translate-message/translate-message.pipe");
var warning_page_component_1 = require("./warning-page/warning-page.component");
var translate_placeholder_message_pipe_1 = require("./translate-message/translate-placeholder-message.pipe");
var DeControlsModule = /** @class */ (function () {
    function DeControlsModule() {
    }
    DeControlsModule = __decorate([
        core_1.NgModule({
            declarations: [
                sis_audit_trail_component_1.AuditTrailComponent,
                sis_document_row_component_1.DocumentItemComponent,
                de_export_component_1.DeExportComponent,
                translate_message_pipe_1.TranslateMessage,
                sis_message_box_popup_component_1.MessageBoxPopup,
                warning_page_component_1.WarningPageComponent,
                de_head_menu_component_1.DeHeadMenu,
                sis_entity_search_component_1.EntitySearchComponent,
                translate_placeholder_message_pipe_1.TranslatePlaceholderMessagePipe
            ],
            exports: [
                sis_audit_trail_component_1.AuditTrailComponent,
                sis_document_row_component_1.DocumentItemComponent,
                de_export_component_1.DeExportComponent,
                translate_message_pipe_1.TranslateMessage,
                sis_message_box_popup_component_1.MessageBoxPopup,
                warning_page_component_1.WarningPageComponent,
                de_head_menu_component_1.DeHeadMenu,
                sis_entity_search_component_1.EntitySearchComponent,
                translate_placeholder_message_pipe_1.TranslatePlaceholderMessagePipe
            ],
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                idm_ng_controls_1.ControlsModule,
                forms_1.ReactiveFormsModule,
                material_module_1.MaterialModule
            ],
        })
    ], DeControlsModule);
    return DeControlsModule;
}());
exports.DeControlsModule = DeControlsModule;
//# sourceMappingURL=de-controls.module.js.map